// extracted by css-extract-rspack-plugin
export default {"infoLabel":"UclmqkGg6IDmAfFr","label":"PE0vnLYKvyoDQQ1Y","dialogContent":"yKCgTVNiV80OE9Xp","required":"Q5WJ_fRWNHwB8ux0"};